import { render, staticRenderFns } from "./TaskCopyLinkButton.vue?vue&type=template&id=e7b846c2&scoped=true"
import script from "./TaskCopyLinkButton.vue?vue&type=script&lang=js"
export * from "./TaskCopyLinkButton.vue?vue&type=script&lang=js"
import style0 from "./TaskCopyLinkButton.vue?vue&type=style&index=0&id=e7b846c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b846c2",
  null
  
)

export default component.exports